var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('editor',{ref:"editor",class:_vm.editing,attrs:{"config":_vm.getConfig(),"initialized":_vm.ready}})}
var staticRenderFns = []

export { render, staticRenderFns }